import React, { useCallback, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { ModalComponent } from '../base2';
import { VERSION } from '../env';
import { useLogout } from '../hooks';

import { AuthUserContext } from './auth-component';
import { Button } from './basic-inputs';
import { LifeSaver } from './logo';


type HeaderProps = {
  hide?: boolean;
};

export function HeaderComponent({ hide }: HeaderProps) {
  const navigate = useNavigate();
  const { user, setUser } = useContext(AuthUserContext);

  const { handleLogout, loading } = useLogout();

  const [ showMenu, setShowMenu ] = React.useState(false);
  const [ showModal, setShowModal ] = React.useState(false);
  
  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const handleShowModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleLogoutResult = useCallback(async () => {
    const result = await handleLogout();

    if (result.success) {
      setUser(null);
      navigate('/');
    }
  }, [ handleLogout, navigate, setUser ]);

  const toggleMenu = useCallback(() => {
    setShowMenu(!showMenu);
  }, [ showMenu ]);

  if (hide) {
    return null;
  }

  const style = {
    display: showMenu ? 'block' : 'none',
  };

  return (
    <div className="header-component">
      {/* <AfterLife /> */}
      <LifeSaver />
      <span
        className="material-symbols-outlined main-menu-icon"
        onClick={toggleMenu}
      >
        menu
      </span>
      {/* <Button onClick={handleLogoutResult} disabled={loading}>
        Log out
      </Button> */}
      <div style={style} className="main-menu">
        {
          user.isAdmin &&
            <div className="main-menu-item">
              <Link to="/admin">
                Admin Panel
              </Link>
            </div>
        }
        <div className="main-menu-item">
          Menu Item 2
        </div>
        <div className="main-menu-item" onClick={handleShowModal}>
          Show Version
        </div>
        <div className="main-menu-item">
          <Button onClick={handleLogoutResult} disabled={loading} fullWidth>
            Log out
          </Button>
        </div>
        <ModalComponent showModal={showModal} closeModal={handleCloseModal}>
          <div>
            Version: {VERSION}
          </div>
        </ModalComponent>
      </div>
    </div>
  );
}
